module.exports = __webpack_public_path__ + "img/index.2d13fe15.jpg";